import axios from "@/axios";

const state = {
  loadingDatePoint: false,
  loadingDateRequest: false,
  loadingCustomerSingle: false,
  loadingPointCash: false,
  loadingUserPoint: false,
  loadingUserPointPayment: false,
};

const actions = {
  async SendDatePoint({commit}, payload) {
    try{
      commit('LOADING_DATE_POINT', true);
      const point = await axios.post('admin/score/chart/date',payload)
      return point
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING_DATE_POINT', false);
    }
  },
  async SendDateRequest({commit}, payload) {
    try{
      commit('LOADING_DATE_REQUEST', true);
      const request = await axios.post('admin/score/chart/exchange',payload)
      return request
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING_DATE_REQUEST', false);
    }
  },
  async CustomerSingle({commit}, payload){
    try{
      commit('LOADING_CUSTOMER_SINGLE', true);
      const customer = await axios.get(`admin/score/chart/customer/${payload.customer_id}`,payload)
      return customer
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING_CUSTOMER_SINGLE', false);
    }
  },
  async PointCash({commit}, payload){
    try{
      commit('LOADING_POINT_CASH', true);
      const cash = await axios.post('admin/badadv/query/date',payload)
      return cash
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING_POINT_CASH', false);
    }
  },
  async SumUserPoint({commit}, payload){
    try{
      commit('LOADING_USER_POINT', true);
      const {data} = await axios.post('admin/score/query/sum',payload)
      return data
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING_USER_POINT', false);
    }
  },
  async SumUserPointPayment({commit}, payload){
    try{
      commit('LOADING_USER_POINT_PAYMENT', true);
      const {data} = await axios.post('admin/score/query/payment',payload)
      return data
    }
    catch (e) {
      this.$ntSetError()
    }
    finally {
      commit('LOADING_USER_POINT_PAYMENT', false);
    }
  }
};

const mutations = {
  LOADING_DATE_POINT(state, payload) {
    state.loadingDatePoint = payload;
  },
  LOADING_DATE_REQUEST(state, payload) {
    state.loadingDateRequest = payload;
  },
  LOADING_CUSTOMER_SINGLE(state, payload) {
    state.loadingCustomerSingle = payload;
  },
  LOADING_POINT_CASH(state, payload) {
    state.loadingPointCash = payload;
  },
  LOADING_USER_POINT(state, payload) {
    state.loadingUserPoint = payload;
  },
  LOADING_USER_POINT_PAYMENT(state, payload) {
    state.loadingUserPointPayment = payload;
  }
};



export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
